<!-- TEMPLATE -->
<template>
    <div class="wrapper">
        <dean-dialog
            :title="title"
            :small="true"
        >
            <slot><!--Slot for load overlay-->

            </slot>
            <fade-transition group>
                <dean-select-form-row placeholder="Kies een nieuwe status" label="Nieuwe status"
                                      :options="statusOptions()"
                                      :value="status"
                                      :clearable="false"
                                      :required-field="true"
                                      id="statusOptions" key="statusOptions"
                                      @input="setStatus($event)"></dean-select-form-row>
            </fade-transition>

            <span slot="dean-dialog-button-group">
                <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
                <dean-button :success="status" :dialog-button="true" :disabled="!status" @click.native="statusChange()">Versturen</dean-button>
            </span>
        </dean-dialog>
    </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    // SVG
    warningIcon,
    saveIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {FadeTransition} from 'vue2-transitions';
  import {deanDialogBus} from '@/main';

  // Statuses
  const LEAD = 'lead';
  const END = 'end';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
  })

  export default class PartnerStatusChangeDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: any,
    };

    public options: [] = [];
    public status: {
      value: string,
      label: string,
    } | null = null;
    public originalStatus: {
      value: string,
      label: string,
    } | null = null;

    // COMPUTED
    get title() {
      return 'Status wijzigen';
    }

    get text() {
      return `De status van de klant is: `;
    }

    // METHODS
    public created() {
      if (this.payloadData.status === 0) {
        this.originalStatus = {
          value: LEAD,
          label: this.translateStatus(LEAD),
        };
      } else if (this.payloadData.status === 1) {
        this.originalStatus = {
          value: END,
          label: this.translateStatus(END),
        };
      }

      this.status = this.originalStatus;
    }

    public close() {
      deanDialogBus.$emit('close');
    }

    public statusChange() {
      this.$emit('setLoad', true);

      const url = `/-/trade/api/partner.${
        this.status?.value === LEAD
          ? 'undelete'
          : this.status?.value === END
          ? 'delete'
          : 'unknown'
      }`;

      axios.post(url, {
        id: this.payloadData.id,
      }).then(
          (response) => {
            deanDialogBus.$emit('partnerStatusChange');
            this.$toast({
              icon: saveIcon,
              text: `Status is veranderd ${this.status ? `naar: ${this.translateStatus(this.status.value)}` : ''}`,
              theme: 'success',
            });
            this.close();
          },
          (error) => {
            this.$toast({
              icon: warningIcon,
              text: 'De status kan momenteel niet veranderd worden, probeer het later opnieuw.',
              theme: 'warning',
            });
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public setStatus(event: any) {
      this.status = event;
    }

    public statusOptions() {
      const options = [
        ...(
          this.originalStatus?.value === END
          ? [{value: LEAD, label: this.translateStatus(LEAD)}] : []),
        ...((
          this.originalStatus?.value === LEAD
          ||
          !this.originalStatus
        )
          ? [{value: END, label: this.translateStatus(END)}] : []),
      ];

      return options;
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }

    private translateStatus(status: string): string {
      switch (status) {
        case LEAD:
          return 'Actief';
        case END:
          return 'Verwijderd';
        default:
          return 'Onbekend';
      }
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
    // IMPORT
    @import '~@deanone/dean-components/src/scss/vars';
</style>
